var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createHashHistory } from 'history';
import { applyMiddleware, compose, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'connected-react-router';
import createDebounce from 'redux-debounced';
import createRootReducer from './reducers';
import { all, fork } from "@redux-saga/core/effects";
import i18nSaga from "./sagas/i18n";
import actionWatcher from "./sagas/main";
import schemaSaga from "./sagas/schema";
import { loadConfiguration } from "./actions/axios";
export var history = createHashHistory();
var sagaMiddleware = createSagaMiddleware();
function configureStore(preloadedState, sagasToFork, reducers) {
    if (sagasToFork === void 0) { sagasToFork = []; }
    var store = createStore(createRootReducer(reducers, history), preloadedState, compose(applyMiddleware(routerMiddleware(history), createDebounce(), sagaMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : function (f) { return f; }));
    function rootSaga() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4, all([
                        fork(actionWatcher),
                        fork(i18nSaga),
                        fork(schemaSaga),
                    ].concat(sagasToFork.map(function (saga) { return fork(saga); })))];
                case 1:
                    _a.sent();
                    return [2];
            }
        });
    }
    sagaMiddleware.run(rootSaga);
    store.dispatch(loadConfiguration(store));
    return store;
}
export default configureStore;
